/**
 * * Todo serviço implementa essa classe
 */
export default class BaseService {
  private readonly basePath: string

  constructor(basePath: string) {
    this.basePath = basePath
  }

  private resolveApiUrl(relativePath: string): string {
    const resolve = useResolveApiUrl()
    return resolve(relativePath)
  }

  protected getFullBaseUrl(): string {
    return this.resolveApiUrl(`/services/${this.basePath}`)
  }

  protected getFullApiBaseUrl(): string {
    return this.resolveApiUrl(`/v1.0/${this.basePath}`)
  }
}
